import NavGlobal from '../../components/navGlobal/navGlobal';
import NavSection from '../../components/navSection/navSection';
import NavSectionSubnav from '../../components/navSection/navSectionSubnav';

import NavSigninLoader from '../../components/account/NavSigninLoader';

//check if nav exists first
if(document.getElementById("global-nav")){
	new NavGlobal();
	var navSigninLoader = new NavSigninLoader();
	navSigninLoader.init();

	var topLevel = document.querySelector( '.section-nav .top-level' );

	if( null !== topLevel && topLevel !== undefined ){
	    new NavSection();
	}

	var subNav = document.querySelector( '.section-front-navigation' );

	if( null !== subNav && subNav !== undefined ){
	    new NavSectionSubnav();
	}
}





// WEBPACK FOOTER //
// ./assets/layouts/base/header.js